import styled from "styled-components";
import { Grid } from "../../components/layout";

import { Permission } from "../../components/permission";
// import { AMLMasteryCourse } from "./tiles/aml";
import { useBrowserWallet } from "../../store/wallets/crypto";
import { PreviousKycPacks } from "./previous-kyc-packs";
import { KYCPackForm } from "./kyc-pack-form";

const StyledGrid = styled(Grid)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

export const KYCPackPage = () => {


    return (
        <>
            <Permission
                roles={["ROLE_USER"]}
                alternative={
                    <>

                    </>
                }
            >
                <StyledGrid col-lg={1} col-xs={1} col-sm={1}>
                    <Grid col-xs={1}>

                        <KYCPackForm />

                    </Grid>
                </StyledGrid>

                <StyledGrid col-lg={1} col-xs={1} col-sm={1}>
                    <Grid col-xs={1}>
                        <PreviousKycPacks />

                    </Grid>
                </StyledGrid>

            </Permission>
        </>
    );
};
